import React from 'react';
import PropTypes from 'prop-types';

const MetaTags = ({ type, tcmAgeRange, usaAgeRange, userLocation }) => {
  const metatagClasses = `meta-tag like-small fw-medium`;

  return (
    <ul className="meta-tags inline-list-new inline-list-new--xs">
      {type && <li><span className={`${metatagClasses} color-${type}`}>{type}</span></li>}
      {tcmAgeRange && <li><span className={metatagClasses}>{userLocation === `us` ? usaAgeRange : tcmAgeRange}</span></li>}
    </ul>
  );
};

MetaTags.propTypes = {
  type: PropTypes.string.isRequired,
  tcmAgeRange: PropTypes.string,
  usaAgeRange: PropTypes.string,
  userLocation: PropTypes.string,
};

export default MetaTags;



// WEBPACK FOOTER //
// ./library/app/components/Global/Links/MetaTags.js